import React from 'react'

import styled from 'styled-components'

const StyledCard = styled.div`
  width: ${({ cardWidth }) => {
    return cardWidth + 'px;'
  }}
  margin: 20px 20px;
  @media (max-width: 700px) {
    width: 100%;
  }
  display: flex;
  flex-direction: ${({ checked }) => {
    return checked ? 'row' : 'column'
  }};
  align-items: flex-start;
  .checkIcon img {
    width: 36px;
    height: 36px;
    @media (max-width: 700px) {
      width: 24px;
      height: 24px;
    }
  }
  .cardContent {
    margin-left: 20px;
  }
  ${({ border }) => border && `
    border: 1px solid #D5D4F9;
    border-radius: 8px;
    padding: 30px 30px;
    box-sizing: border-box;
    p:first-child, h3:first-child {
      margin-top: 0px;
    }
    p:last-child {
      margin-bottom: 0px;
    }
  `}
  ${({ background }) => background && `
    background: ${background}
  `}
`

const Card = ({ card, cardWidth = 360, background, border, checked }) => {
  return (
    <StyledCard cardWidth={cardWidth} background={background} border={border} checked={checked}>
      {checked &&
        <div className='checkIcon'>
          <img alt='check' src='https://webassets.mongodb.com/_com_assets/cms/checkmark-frwttwkjav.svg' />
        </div>}
      {card}
    </StyledCard>
  )
}

const StyledCardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  direction: flex-row;
  justify-content: start;
  @media (max-width: 700px){
    justify-content: center;
  }
  margin: 0px -20px;
`

const CardGrid = ({ cards, border, cardWidth, background, checked }) => {
  return (
    <div>
      <StyledCardGrid>
        {cards.map((card, i) => {
          return <Card key={i} card={card} cardWidth={cardWidth} background={background} border={border} checked={checked} />
        })}
      </StyledCardGrid>
    </div>
  )
}

export default CardGrid
